<template>
    <div class="banner-background-area banner-gradient-bg section-space--ptb_120">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="banner-content__start-up">
                        <div class="content-wrapper text-center">
                            <h2 class="heading_title text-white font-weight--bold wow move-up">{{ $t('title') }}</h2>
                            <div class="banner__text mt-10 text-white wow move-up">{{ $t('detail') }}</div>
                            <div class="start-ups-background__links section-space--mt_40 wow move-up">
                                <router-link :to="{ path: '/contact' }" class="btn btn--white">{{ $t('button') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CtaFour',
    }
</script>

<i18n>
{
  "en": {
    "title": "Join the adventure!",
    "detail": "The power is in your hands now.",
    "button": "✨ Join The Beta ✨"
  },
  "fr": {
    "title": "Rejoignez l'aventure !",
    "detail": "La balle est dans votre camp.",
    "button": "✨ Rejoindre La Beta ✨"
  }
}
</i18n>